
import * as u from './utils';
import noScroll from 'no-scroll';

export default () => {
    const openButton = document.querySelector('.attachment-archive__display-filters');
    const sidebar = document.querySelector('.attachment-archive__sidebar');
    const close = document.querySelector('.attachment-archive__sidebar-close');

    if (!openButton) {
        return;
    }

    const toggleSidebar = () => {
        u.toggleClass(sidebar, 'is-active');
        noScroll.toggle();
    };

    openButton.addEventListener('click', toggleSidebar);
    close.addEventListener('click', toggleSidebar);
};
